export default {
  registration: {
    name: "Name",
    institution: "Einrichtung",
    component: "Komponente",
    trainingCourse: "Gruppe",
    group: "Gruppe",
    Contact: "Kontakt",
    TrainingContact: "Ausbildungskontakt",
    pedagogicInformations: "Pädagogische Informationen",
    fundingInformations: "Finanzinformationen",
    dates: "Daten",
    from_to: "vom {from} bis {to}",
    hourlyVolume: "Stundenvolumen",
    hourlyRemoteVolume: ({ named }) => `Davon ${named("volume")} Std. Fernunterricht`,
    modality: ({ plural }) => plural(["Modalität", "Modalitäten"]),
    in_person: "Präsenz",
    distanciel: "Fernunterricht",
    remoteVolume: "Davon Fernunterricht",
    degreePrepared: "Angestrebter Abschluss",
    level: "Niveau",
    titleRncp: "RNCP-Titel",
    degreeCode: "Abschlusscode",
    calendar: "Kalender",
    program: "Programm",
    apprenticeShipContract: "Ausbildungsvertrag",
    proContract: "Professionalisierungsvertrag",
    rate: "Tarif",
    publicAnnualRate: "Jährliche Kosten öffentliche Arbeitgeber",
    annualRate: "Jährliche Kosten",
    totalRate: "Gesamtkosten",
    hourlyRate: "Stundentarif",
    followUp: "Aktenverfolgung",
    devices: "Geräte",
    createdAt: "erstellt am {date}",
    help: "Hilfe",
    follow: "Verfolgung",
    inProgress: "In Bearbeitung",
    validatedAt: "Validiert am {date} von {validator}",
    steps: "Die Schritte",
    statistics: "Statistiken",
    generalInformations: "Allgemeine Informationen",
    civility: "Anrede",
    firstName: "Vorname",
    birthDate: "Geburtsdatum",
    age: "Alter",
    email: "E-Mail",
    phone: "Telefon",
    address: "Adresse",
    nationality: "Nationalität",
    male: "Herr",
    female: "Frau",
    years: "Jahre",
    apprentice: "Auszubildende(r)",
    tutor: "Betreuer",
    map: "Ausbildungsmeister",
    function: "Funktion",
    contacts: "Kontakte",
    previousSituation: "Frühere Situation",
    ineCode: "INE-Code",
    preContractSituation: "Situation vor dem Vertrag",
    lastDegreeObtained: "Letzter erworbener Abschluss",
    title: "Bezeichnung",
    lastDegreePrepared: "Letzter vorbereiteter Abschluss",
    lastInstitution: "Letzte Einrichtung",
    uaiCode: "UAI-Code",
    department: "Département",
    socialReason: "Firmenname",
    company: "Unternehmen",
    head_office: "Firmensitz",
    activityCode: "Aktivitätscode (NAF)",
    totalWorkForce: "Gesamtbelegschaft",
    siret: "SIRET",
    employerType: "Arbeitgebertyp",
    employerSubType: "Arbeitgeber-Untertyp",
    idcc: "IDCC",
    opco: "OPCO",
    hostCompany: "Aufnahmeunternehmen",
    administratorCompany: "Firmensitz",
    training: "Ausbildung",
    startDate: "Startdatum",
    endDate: "Enddatum",
    hourlyTrainingVolume: "Stundenanzahl",
    apprenticeMaster: "Ausbildungsmeister",
    apprenticeMaster2: "Ausbildungsmeister 2",
    degree: "Abschluss",
    hostCompanyContact: "Kontakt Aufnahmeunternehmen",
    administratorCompanyContact: "Kontakt Firmensitz",
    pricePolicyInfo1:
      "Restkosten nur wenn die Übernahme geringer ist; die Übernahme auf den Tarif begrenzt, auch wenn sie höher ist.",
    pricePolicyInfo2:
      "Restkosten nur wenn die Übernahme geringer als der Tarif ist; wenn höher, wird der Tarif entsprechend der Übernahme angewendet.",
    pricePolicyInfo3: "Der Tarif wird an die Übernahme angepasst.",
    signIn: "Konto erstellen",
    login: "Anmelden",
    loginInfo: "Authentifizieren Sie sich oder erstellen Sie ein Konto, um auf das Anmeldeformular zuzugreifen",
    loginInfo2: "Authentifizieren Sie sich, um auf das Anmeldeformular zuzugreifen",
    needAccount: "Ich habe kein Konto",
    noNeedAccount: "Ich habe bereits ein Konto",
    anApprentice: "Ein/e Alternant/e",
    aCompany: "Ein Unternehmen",
    iAm: "Ich bin",
    createApprenticeAccount: "Alternant/e-Konto erstellen",
    createCompanyAccount: "Unternehmenskonto erstellen",
    accountExist: "Ihre E-Mail wurde erkannt!",
    accountExistSubTitle: "Sie können sich direkt mit Ihren Anmeldedaten in Ihrem Konto anmelden!",
    next: "Weiter",
    prev: "Zurück",
    workInProgress: "Zu validieren",
    valid: "Validiert",
    pending: "In Bearbeitung",
    publicSector: "Öffentlicher Sektor",
    privateSector: "Privatsektor",
    link_copied_success: "Link erfolgreich in die Zwischenablage kopiert!",
    status: {
      upcoming: "Bevorstehend",
      in_progress: "In Bearbeitung",
      finalised: "Abgeschlossen",
      break_up: "Auflösung",
      cancelled: "Abgebrochen",
    },
    insee_company: {
      title: ({ plural }) => plural(["INSEE-Unternehmen", "INSEE-Unternehmen"]),
      siret: "SIRET",
      activity: "Aktivität (NAF/APE)",
      details: "Details (Name, Bezeichnung, Adresse)",
      creation: "Gründung",
      state: "Status",
      social_reason: "Firmenname",
      current: "Aktueller Betrieb",
      head_office: "Firmensitz",
      creation_date: "Gründungsdatum",
      work_force: "Belegschaft",
      status: "Status",
      principal_address: "Hauptadresse",
      secondary_address: "Nebenadresse",
      empty_contact: "Für dieses Unternehmen ist kein Kontakt eingetragen",
    },
    training_info: {
      search_by_branch: "Suche nach Tarifvertrag",
      funding_coverage: "Übernahme:",
      decree_cost: "Dekretkosten: ",
      only_different_cost_displayed: "Standardmäßig werden nur Kosten angezeigt, die von den Dekretkosten abweichen",
      info_tab: {
        general_info: "Allgemeine Informationen",
        rncp_sheet: "RNCP-Blatt",
        settings: "Anmeldungskonfiguration",
        npec: "NPEC",
        contact: "Kontakt für Unternehmen",
      },
      general_info: {
        institution_name: "Name der Einrichtung",
        reference: "Referenz",
        rncp_number: "RNCP-Nummer",
        offical_name: "Offizieller Name",
        diplome_type: "Abschlussart",
        mention: "Name / Bezeichnung",
        route: "Weg",
        diplome_code: "Abschlusscode",
        status: "Status",
        logo: "Logo",
        partner_website_url: "URL der Partner-Website",
        link: "Link",
        work_study_duration: "Dauer der Wechselausbildung",
        total_cycle_time: "Gesamtdauer des Zyklus",
        active: "Aktiv",
        archived: "Archiviert",
      },
    },
    alert: {
      title: ({ plural }) => plural(["Warnung", "Warnungen"]),
      level: {
        info: "Information",
        warning: "Warnung",
        error: "Fehler",
      },
      active_unactive: "Aktivieren/Deaktivieren",
      see_more: "Mehr anzeigen",
      empty: "Keine Warnung auf Ebene {level}",
    },
    group_action: {
      see_sheet: "Voranmeldeformular anzeigen",
      copy_sheet: "Link des Voranmeldeformulars kopieren",
      create: "Voranmeldeformular erstellen",
      delete: {
        confirmation: "Möchten Sie diese Gruppe wirklich löschen?",
        success: "Gruppe erfolgreich gelöscht!",
      },
    },
    dashboard: {
      go_to: "Zum Dashboard dieser Ausbildung wechseln",
    },
    creation: {
      info: "Um ein neues Anmeldeformular zu erstellen, geben Sie bitte zuerst die Kandidatendaten ein",
      success: ({ named }) => `Voranmeldeformular von ${named("firstName")} ${named("lastName")} erfolgreich erstellt!`,
    },
    user_not_connected: "Sie müssen sich anmelden, um auf diesen Bereich zuzugreifen",
    quote: {
      contract: "Vertrag",
      financial: "Finanzierung",
      amount: "Betragstabelle",
      edit_cost: "Kosten bearbeiten",
      subtitle: "Finanzielle Zusammenfassung des Ausbildungsvertrags",
      initial_cost: "Anfangskosten",
      final_cost: "Endkosten",
      modal_alert:
        "Diese Änderungen wirken sich auf den dem Unternehmen berechneten Betrag aus. Stellen Sie sicher, dass die Beträge Ihrer Vereinbarung entsprechen.",
      discount: ({ named }) => `Handelsrabatt: ${named("economy")} (${named("discount")})`,
      edit: {
        date: {
          title: "Vertragsdaten bearbeiten",
          success: "Änderung der Vertragsdaten erfolgreich durchgeführt!",
        },
        cost: {
          title: "Beträge bearbeiten",
          success: "Beträge erfolgreich geändert!",
        },
      },
      table: {
        columns: {
          trainingCourseCost: "Ausbildungskosten",
          opcoo: "Übernahme",
          mandatory_participation: "Pflichtbeitrag",
          remaining_cost: "Restkosten",
        },
      },
      duration: {
        title: "Dauer",
      },
      billingStartDate: {
        title: "Startdatum",
      },
      billingEndDate: {
        title: "Enddatum",
      },
    },
    contact: {
      success: "Kontakt erfolgreich hinzugefügt!",
    },
    contractType: {
      apprentice: "Auszubildende",
      pro: "Professionalisierungsvertrag",
    },
    document: {
      baseline: "Dokument zum Ausdrucken, Unterzeichnen und unten hochladen",
      cerfa: {
        title: "CERFA",
      },
      convention: {
        title: "Vereinbarung",
      },
      update: {
        success: ({ named }) => `Ihr ${named("document")} wurde erfolgreich gespeichert!`,
      },
    },
    step: {
      validation: {
        success: "Schritt erfolgreich validiert!",
      },
    },
    save: {
      success: "Ihr Anmeldeformular wurde erfolgreich gespeichert!",
    },
    download_training_sheet: "Ausbildungsinformationsblatt herunterladen",
    create: {
      confirmation: "Möchten Sie wirklich ein neues Voranmeldeformular erstellen?",
    },
    empty_document: "Keine Dokumente",
    empty_registation_list: "Kein Registrierungsformular verfügbar",
    init: "Initialisiert",
    see: "Vertrag öffnen",
    see_group_detail: "Gruppendetail anzeigen",
    sent_to_training_center: "Versendet",
    signed: "Unterzeichnet",
    to_send_to_training_center: "Zum Versand bereit",
    validated_training_center: "Validiert",
    company_dashboard: "Unternehmens-Dashboard",
    contract_status: "Vertragsstatus",
  },
};
